<div class="filter-container">
  <div class="filter-header">
    <div class="filter-title mt-1">
      {{ tableFilter().title }}
    </div>
    <lib-button [type]="ButtonType.tertiary" [size]="InputSize.small" (buttonClick)="resetClicked()" i18n>
      Reset
    </lib-button>
  </div>
  <div class="mt-3 pill-container">
    @for (filterOption of tableFilter().unsavedOptions; track $index) {
      <lib-interactive-pill
        [titleText]="filterOption.name"
        [selected]="filterOption.isSelected?.() ?? false"
        (pillClick)="pillOptionsClicked(filterOption)"></lib-interactive-pill>
    }
  </div>
</div>
